import { Client } from '@/pages/user/api';

let apiPrefix = 'portal';

export interface ProductPageQuery {
  keyword?: string;
  supplierEnterpriseSn?: string;
  studioName?: string;
  firstCategoryCode?: string;
  secondCategoryCode?: string;
  pageNum: number;
  pageSize: number;
}

export interface ProductPriceItem {
  sizeOptionSn: string;
  unitPrice: number | string;
  sequence?: number;
}

export interface ProductCreatePayload {
  name: string;
  imageUrl: string;
  detailImageUrls?: string[];
  supplierEnterpriseSn: string;
  studioName?: string;
  proofNotice?: string;
  minQuantity: number;
  stepQuantity: number;
  priceList: ProductPriceItem[];
}

export interface ProductUpdatePayload extends ProductCreatePayload {
  productSn: string;
}

export interface ProductDetailQuery {
  productSn: string;
}

export interface ProductDeletePayload {
  productSn: string;
}

export const GetProductPage = async (data: ProductPageQuery): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/product/manage/page',
    data,
  });
};

export const GetProductDetail = async (data: ProductDetailQuery): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/product/manage/detail',
    data,
  });
};

export const CreateProduct = async (data: ProductCreatePayload): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/product/manage/create',
    data,
  });
};

export const UpdateProduct = async (data: ProductUpdatePayload): Promise<any | null> => {
  return await Client.put<any>({
    url: apiPrefix + '/product/manage/update',
    data,
  });
};

export const DeleteProduct = async (data: ProductDeletePayload): Promise<any | null> => {
  return await Client.delete<any>({
    url: apiPrefix + '/product/manage/delete',
    data,
  });
};

export const GetProductSizeOptions = async (): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/product/manage/sizeOptions',
  });
};

export const GetProductSupplierOptions = async (data?: { keyword?: string }): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/product/manage/supplierOptions',
    data,
  });
};
